// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';
import { handleTagEvent }from 'utils/tagManagerUtils';

type Props = {
  title: string,
  results: number,
  small?: boolean,
  slug: string
};

class CompetitionRow extends PureComponent<Props> {
  static defaultProps = {
    title: 'Competition',
    results: 0,
    small: false
  };

  render() {
    const { title, results, small, slug } = this.props;

    const containerClassName = dynamicClassName('link-competition ');
    small && containerClassName.add('link-competition--card');

    const resultClassName = dynamicClassName(' ');
    results > 0 && resultClassName.add('link-competition__count');
    results === 0 && resultClassName.add('link-competition__empty');

    return (
      <Link
        className={containerClassName.build()}
        to={`/competitions/${slug}`}
        onClick={handleTagEvent('module competitions', `clic ${title}`, window.location.pathname)}>
        <div>
          <span className="link-competition__title ft-h4">
            {title}
            <i className="icon icon-chevron-right" />
          </span>
          <span className={resultClassName.build()}>
            {results ? results + ' nouveau(x) résultat(s)' : 'Aucun nouveau résultat'}
          </span>
        </div>
      </Link>
    );
  }
}

export default CompetitionRow;
